<template>
  <div>
    <form role="form" @submit.stop.prevent="emitForm">
      <div class="vx-row">
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <label for="Tipo de Operação" class="vs-select--label">Tipo de Operação</label>
          <v-select
            :options="tiposBoletos"
            name="Tipo de Operação"
            id="Tipo de Operação"
            label="label"
            :reduce="(item) => item.id"
            v-model="form.purchaseTypeId"
            v-validate="{ required: true }"
            class="w-full"
            :state="validateState(veeFields, veeErrors, 'Tipo de Operação')"
            :class="
              validateStateClass(veeFields, veeErrors, 'Tipo de Operação')
            "
          >
          </v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label for="Descrição" class="vs-input--label">Descrição</label>
          <vs-input
            class="w-full"
            name="Descrição"
            id="Descrição"
            placeholder="Referente à"
            v-model="form.description"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Descrição')"
            :class="validateStateClass(veeFields, veeErrors, 'Descrição')"
          />
        </div>
      </div>

      <div class="vx-row">
        <div
          v-if="paymentMethods.length > 0"
          class="vx-col sm:w-1/2 w-full mb-2"
        >
          <label for="Forma de Pagamento" class="vs-select--label">Forma de Pagamento</label>
          <v-select
            :options="paymentMethods"
            class="w-full"
            name="Forma de Pagamento"
            id="Forma de Pagamento"
            label="paymentName"
            v-model="form.paymentMethod"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Forma de Pagamento')"
            :class="
              validateStateClass(veeFields, veeErrors, 'Forma de Pagamento')
            "
            @input="defineInstallmentsQuantity"
          >
          </v-select>
        </div>

        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="Valor" class="vs-input--label">Valor</label>
          <money
            class="w-full vs-inputx vs-input--input normal"
            name="Valor"
            id="Valor"
            v-model="form.value"
            v-validate="{ required: true, min_value: minChargeValue }"
            :state="validateState(veeFields, veeErrors, 'Valor')"
            :class="validateStateClass(veeFields, veeErrors, 'Valor')"
            v-bind="money"
          ></money>
        </div>
      </div>

      <div v-if="chooseCreditCard" class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="Data de Vencimento" class="vs-input--label"
            >Data de Vencimento do Link de Pagamento</label
          >
          <flat-pickr
            name="Data de Vencimento do Link de Pagamento"
            id="Data de Vencimento do Link de Pagamento"
            v-model="form.paymentLinkExpirationDate"
            v-validate="{ required: true }"
            class="w-full flat-Pickr"
            :class="
              veeErrors.has('Data de Vencimento do Link de Pagamento')
                ? 'flatpickr-danger'
                : ''
            "
            :config="{ ...configdateTimePickerDay }"
            placeholder="DD/MM/AAAA"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="N° Max de Parcelas" class="vs-input--label">N° Max de Parcelas</label>
          <v-select
            :options="installments"
            class="w-full"
            name="N° Max de parcelas"
            id="N° Max de parcelas"
            v-model="form.creditCardMaxInstallments"
            :reduce="(item) => item.id"
            label="id"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'N° Max de parcelas')"
            :class="
              validateStateClass(veeFields, veeErrors, 'N° Max de parcelas')
            "
          >
          </v-select>
        </div>
      </div>

      <div v-if="chooseBillet" class="vx-row">
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <label for="Carteira de Cobrança" class="vs-select--label">Carteira de Cobrança</label>
          <v-select
            :options="wallets"
            name="Carteira de Cobrança"
            id="Carteira de Cobrança"
            label="walletName"
            v-model="form.wallet"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Carteira de Cobrança')"
            :class="
              validateStateClass(veeFields, veeErrors, 'Carteira de Cobrança')
            "
            @input="setDefaultWalletConfigs()"
            class="w-full"
          >
          </v-select>
        </div>
      </div>

      <div v-if="chooseBillet" class="vx-row">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <label for="Data de Vencimento" class="vs-input--label"
            >Data de Vencimento</label
          >
          <flat-pickr
            name="Data de Vencimento"
            id="Data de Vencimento"
            v-model="form.dueDate"
            v-validate="{ required: true }"
            class="w-full flat-Pickr"
            :class="
              veeErrors.has('Data de Vencimento') ? 'flatpickr-danger' : ''
            "
            :config="{ ...configdateTimePickerDay }"
            placeholder="DD/MM/AAAA"
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <label for="N° de Parcelas" class="vs-input--label">N° de Parcelas</label>
          <v-select
            :options="installments"
            v-model="form.billetInstallments"
            name="N° de Parcelas"
            label="label"
            id="N° de Parcelas"
            class="select-large w-full"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'N° de Parcelas')"
            :class="validateStateClass(veeFields, veeErrors, 'N° de Parcelas')"
            :danger="veeErrors.has('N° de Parcelas')"
          >
          </v-select>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <label for="Dias p/ Expiração do Boleto" class="vs-input--label"
            >Dias p/ Expiração do Boleto</label
          >
          <vs-input
            type="number"
            class="w-full"
            name="Dias p/ Expiração do Boleto"
            id="Dias p/ Expiração do Boleto"
            v-model="form.expirationDaysSingle"
            v-validate="{ required: true }"
            :state="
              validateState(veeFields, veeErrors, 'Dias p/ Expiração do Boleto')
            "
            :class="
              validateStateClass(
                veeFields,
                veeErrors,
                'Dias p/ Expiração do Boleto',
              )
            "
          />
        </div>
      </div>

      <div v-if="chooseBillet" class="vx-row">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <label for="Aplicar Juros a Partir de Quantos Dias" class="vs-input--label"
            >Aplicar Juros a Partir de Quantos Dias</label
          >
          <vs-input
            type="number"
            class="w-full"
            name="Aplicar juros a partir de quantos dias"
            id="Aplicar juros a partir de quantos dias"
            v-model="form.interestDays"
            v-validate="{ required: true }"
            :state="
              validateState(
                veeFields,
                veeErrors,
                'Aplicar juros a partir de quantos dias',
              )
            "
            :class="
              validateStateClass(
                veeFields,
                veeErrors,
                'Aplicar juros a partir de quantos dias',
              )
            "
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <label for="Juros Diário (%)" class="vs-select--label">Juros Diário (%)</label>
          <money
            class="w-full vs-inputx vs-input--input normal"
            name="Juros Diário (%)"
            id="Juros Diário (%)"
            v-model="form.dailyInterestRate"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Juros Diário (%)')"
            :class="
              validateStateClass(veeFields, veeErrors, 'Juros Diário (%)')
            "
            v-bind="money"
          ></money>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <label for="Multa (%)" class="vs-select--label">Multa (%)</label>
          <money
            class="w-full vs-inputx vs-input--input normal"
            name="Multa %"
            id="Multa %"
            v-model="form.finePercentage"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Multa %')"
            :class="validateStateClass(veeFields, veeErrors, 'Multa %')"
            v-bind="money"
          ></money>
        </div>
      </div>

      <div class="vx-row mb-4"></div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row mt-2">
        <div class="vx-col w-full text-right">
          <vs-button color="success">Gerar</vs-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import service from './../../services';
import { Money } from 'v-money';
import * as lang from 'vuejs-datepicker/src/locale';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import utilsList from '../../utils/list';

import ErrorsAlert from '../../components/ErrorsAlert.vue';
import notify from '../../utils/notify';
import looseChargeApi from '../../services/loose-charge.api';
import autoApi from '../../services/auto.api';
import walletsApi from '../../services/wallets.api';
import vSelect from 'vue-select';
import functions from '../../utils/functions';

export default {
  props: ['idSegurado', 'apolices'],
  watch: {
    idAssociado() {
      this.preencheForm();
    },
  },
  components: {
    Money,
    flatPickr,
    ErrorsAlert,
    'v-select': vSelect,
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
    chooseBillet() {
      return (
        this.form.paymentMethod &&
        this.form.paymentMethod.paymentName === this.billetLabel
      );
    },
    chooseCreditCard() {
      return (
        this.form.paymentMethod &&
        this.form.paymentMethod.paymentName === this.creditCardLabel
      );
    },
    minChargeValue() {
      return this.chooseBillet ? this.minValueBillet : this.minValueCreditCard;
    },
  },
  data() {
    return {
      language: 'br',
      languages: lang,
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      configdateTimePickerDay: {
        minDate: 'today',
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
        disabled: true,
      },
      tiposBoletos: [],
      form: {
        insuredId: null,
        walletId: null,
        policyId: null,
        purchaseTypeId: null,
        description: null,
        value: '',
        dueDate: null,
        billetInstallments: null,
        paymentMethod: null,
        paymentLinkExpirationDate: null,
        creditCardMaxInstallments: null,
        wallet: null,
        expirationDaysSingle: null,
        interestDays: null,
        dailyInterestRate: '',
        finePercentage: '',
      },
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      installments: [],
      paymentMethods: [],
      wallets: [],
      billetLabel: 'Boleto',
      creditCardLabel: 'Cartão de Crédito',
      minValueBillet: 2,
      minValueCreditCard: 1,
    };
  },
  methods: {
    defineInstallmentsQuantity() {
      const installmentQuantity = this.form.paymentMethod.installmentQuantity;

      this.installments = Array.from(
        { length: installmentQuantity },
        (_, indice) => ({
          id: indice + 1,
          label: indice + 1,
        }),
      );

      this.form.installments = null;
      this.form.creditCardMaxInstallments = null;
    },
    preencheForm() {
      this.form.insuredId = this.idSegurado;
      if(this.apolices && this.apolices.length > 0){
        this.form.policyId = this.apolices[0].id;
      }
    },
    async emitForm() {
      const validated = await this.$validator.validateAll();

      if (!validated) {
        notify.notifyFail(this.$vs, 'Existem campos não preenchidos.');
        return;
      }

      if (this.chooseBillet && this.validateValueIndividualBillets()) {
        const individualBillets =
          this.form.value / this.form.billetInstallments;

        notify.notifyFail(
          this.$vs,
          `O valor de cada boleto não pode ser inferior a ${functions.formataReal(
            this.minValueBillet,
          )}. O valor de ${functions.formataReal(
            this.form.value,
          )} dividido em ${
            this.form.billetInstallments
          } parcelas, cada boleto seria de ${functions.formataReal(
            individualBillets,
          )}`,
        );
        return;
      }

      const payload = {
        policyId: this.apolices[0].id,
        insuredId: this.idSegurado,
        purchaseTypeId: this.form.purchaseTypeId,
        paymentMethodId: this.form.paymentMethod.id,
        description: this.form.description,
        value: this.form.value,
      };

      try {
        this.$vs.loading();

        if (this.chooseBillet) {
          Object.assign(payload, {
            walletId: this.form.wallet.id,
            dueDate: this.form.dueDate,
            expirationDaysSingle: +this.form.expirationDaysSingle,
            interestDays: +this.form.interestDays,
            dailyInterestRate: this.form.dailyInterestRate,
            finePercentage: this.form.finePercentage,
            installments: +this.form.billetInstallments,
          });

          await looseChargeApi.createBilletLoose(payload);
        }

        if (this.chooseCreditCard) {
          Object.assign(payload, {
            paymentLinkExpirationDate: this.form.paymentLinkExpirationDate,
            installments: Number(this.form.creditCardMaxInstallments),
          });

          await looseChargeApi.createCheckoutLoose(payload);
        }

        notify.notifySuccess(this.$vs, 'Cobrança(s) geradas com sucesso!');

        this.$vs.loading.close();
        this.resetForm();
        this.$emit('finished', {});
      } catch (error) {
        notify.notifyFail(this.$vs, error.response.data.message || 'Erro ao gerar cobrança.');
      } finally {
        this.$vs.loading.close();
      }
    },
    validateValueIndividualBillets() {
      return this.form.value / this.form.billetInstallments < 2;
    },
    buscaTiposBoletos() {
      service.getAll('boletos', {}, `buscar-tipos-boletos`).then(({ data }) => {
        data.forEach((element) => {
          if (!element.deletedAt) {
            element.id = element.idTipoBoleto;
            element.label = element.tipoBoleto;
            this.tiposBoletos.push(element);
          }
        });
      });
    },
    async getDomains() {
      try {
        this.$vs.loading();

        const promises = [
          walletsApi.getActiveWallets(),
          autoApi.getPaymentMethods(),
        ];

        const [wallets, paymentMethods] = await Promise.all(promises);

        this.wallets = wallets.map((w) => ({
          ...w,
          label: w.walletName,
        }));

        this.paymentMethods = paymentMethods;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    setDefaultWalletConfigs() {
      this.form.expirationDaysSingle = this.form.wallet.expirationDaysSingle;
      this.form.interestDays = this.form.wallet.interestDays;
      this.form.dailyInterestRate = this.form.wallet.dailyInterestRate;
      this.form.finePercentage = this.form.wallet.finePercentage;
    },
    resetForm() {
      this.form = {
        walletId: null,
        purchaseTypeId: null,
        description: null,
        value: '',
        dueDate: null,
        billetInstallments: null,
        paymentMethod: null,
        paymentLinkExpirationDate: null,
        creditCardMaxInstallments: null,
        wallet: null,
        expirationDaysSingle: null,
        interestDays: null,
        dailyInterestRate: '',
        finePercentage: '',
      };
      this.$validator.reset();
      this.installments = [];
    },
  },
  mounted() {
    this.preencheForm();
    this.buscaTiposBoletos();
    this.getDomains();
  },
  created() {},
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.input-data-ativacao {
  width: 100%;
}

.flatpickr-danger {
  border: 1px solid red !important;
}

.flat-Pickr {
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #626262;
}
</style>
